<template>


	<div class="learning-content">
		<div class="inner">
			<div class="test-start">
				<h3>테스트는 총 {{tstCount}}문항 입니다.</h3>
				<p>'테스트 시작' 버튼을 누르면 테스트가 시작됩니다. 테스트 도중에는 중단할 수 없습니다.</p>
				<a href="javascript:;" class="btn btn-lg btn-primary" @click="tstStart">테스트 시작</a>
			</div>
		</div>
	</div>

</template>

<script>

	export default {
		name: "ans-tst-start",
        props: [
        	"tstCount"
        ],
        created: function () {

			//console.log( "ans-tst-start" )
        },
        methods: {

	        tstStart: function () {

	        	this.$emit("tstStart");

	        }

        }
	}
</script>

<style scoped>

</style>